import type React from 'react';

import { useSetPageState } from '../context';

type Props = Readonly<{
	name: string;
	value: unknown;
	persistent?: boolean;
}>;

export const SetPageStateValue: React.FC<Props> = ({ name, value, persistent }) => {
	useSetPageState(name, value, { persistent });

	return null;
};
